module.exports = __webpack_public_path__ + "static/media/students_1st_access_page.31bf2159.mp3";